import React from "react";
import { motion } from "framer-motion";
import { slideInX } from "@/lib/motion-presets";

const SLIDE_LEFT = slideInX(-30);
const SLIDE_RIGHT = slideInX(30);

const Story = () => {
  return (
    <section id="story" className="relative py-24 sm:py-32" data-testid="story-section">
      <div className="max-w-[1400px] mx-auto px-4 sm:px-8 grid grid-cols-1 md:grid-cols-12 gap-12 items-center">
        <motion.div
          {...SLIDE_LEFT}
          transition={{ duration: 0.7 }}
          className="md:col-span-7"
        >
          <div className="eyebrow mb-4">The Story</div>
          <h2 className="font-display text-5xl sm:text-7xl leading-none tracking-tighter mb-6">
            Support local. <br />
            <span className="italic" style={{ color: "var(--awd-ochre)" }}>Celebrate culture.</span>
          </h2>
          <p className="text-lg leading-relaxed mb-4" style={{ color: "var(--awd-text-2)" }}>
            Afro World Delight is a love letter to the kitchens of West Africa — the slow-simmered stews of Ghana, the smoky jollof rivalries of Nigeria, the puff-puff fried golden on a Saturday morning in Lagos.
          </p>
          <p className="text-lg leading-relaxed" style={{ color: "var(--awd-text-2)" }}>
            We're cooking it all from a small kitchen in Omaha, Nebraska — one pre-order at a time, with the same hands and the same heat your auntie would use.
          </p>

          <div className="mt-10 flex flex-wrap gap-3">
            <span className="tag-pill">🇬🇭 Ghana</span>
            <span className="tag-pill">🇳🇬 Nigeria</span>
            <span className="tag-pill">🇹🇬 Togo</span>
            <span className="tag-pill">Family Recipes</span>
          </div>
        </motion.div>

        <motion.div
          {...SLIDE_RIGHT}
          transition={{ duration: 0.7 }}
          className="md:col-span-5 relative"
        >
          <div className="relative h-[440px] overflow-hidden">
            <img
              src="https://customer-assets.emergentagent.com/job_eats-hub-1/artifacts/1wt8psfd_e401725c-1eff-4702-aebe-d6293b848a20.jpeg"
              alt="Plate"
              className="absolute inset-0 w-full h-full object-cover"
            />
            <div className="absolute bottom-0 left-0 right-0 p-6" style={{ background: "linear-gradient(transparent, rgba(15,13,12,0.95))" }}>
              <div className="font-display text-2xl italic" style={{ color: "var(--awd-ochre)" }}>"Bold flavors, made fresh."</div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Story;
